import React from 'react';
import Link from '../Link';
import { linkStyle } from '../styles';

// rows: [{ key, label, sublabel, value, valueLabel, onClick?, href?, onValueClick?, details? }] sorted by value descending; onClick makes the label a link, href makes it a link opening in a new tab,
// onValueClick makes the value a link and details (a node) is rendered below the row
const RankedBars = ({ rows }) => {
    const maxValue = Math.max(...rows.map((row) => row.value), 1);

    const renderLabel = (row) => {
        if (row.onClick) return <Link onClick={row.onClick}>{row.label}</Link>;
        if (row.href) return <a href={row.href} target="_blank" rel="noopener noreferrer" style={linkStyle}>{row.label}</a>;
        return row.label;
    };

    return (
        <div>
            {rows.map((row, i) => (
                <React.Fragment key={row.key}>
                <div style={{ display: 'grid', gridTemplateColumns: '1.5rem minmax(6rem, 10rem) 1fr auto', gap: '0.75rem', alignItems: 'center', padding: '0.3rem 0' }}>
                    <div style={{ fontSize: '0.8rem', color: '#777', textAlign: 'right' }}>{i + 1}.</div>
                    <div style={{ minWidth: 0 }}>
                        <div style={{ fontSize: '0.85rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={row.label}>{renderLabel(row)}</div>
                        {row.sublabel && <div style={{ fontSize: '0.72rem', color: '#777', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={row.sublabel}>{row.sublabel}</div>}
                    </div>
                    <div style={{ backgroundColor: '#eef1f4', borderRadius: '0.25rem', height: '0.9rem' }}>
                        <div style={{ width: `${Math.max((row.value / maxValue) * 100, 0)}%`, height: '100%', backgroundColor: '#1779ba', borderRadius: '0.25rem' }} />
                    </div>
                    <div style={{ fontSize: '0.85rem', whiteSpace: 'nowrap', textAlign: 'right' }}>                    {row.onValueClick ? <Link onClick={row.onValueClick}>{row.valueLabel}</Link> : row.valueLabel}</div>
                </div>
                                    {row.details}
                                    </React.Fragment>
            ))}
        </div>
    );
};

export default RankedBars;
